import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { List } from 'immutable';
import {
    dreamTeamsRoutePath,
    dreamTeamsSelfServeRoutePath
} from '../../constants-types';
import { InvitationSource } from '../../core-data-model';
import { ContextDataService, GroupsDataService } from '../../core-services';
import { PeekService } from '../../core-ui';
import { Util } from '../../core-utilities';
import {
    FeatureFlags,
    FeatureFlagsService,
    ModuleAccessService
} from '../../system-services';
import { TranslationService } from '../../translations';

@Component({
    selector: 'add-new-group',
    template: `
        <group-edit
            [isCreatingGroup]="true"
            (saveHit)="navigateToNewGroup($event)"
            (cancel)="peekService.setOpen(false)"
            [invitationSource]="getInvitationSource()"
            [groupSet]="groupSet"
            [groupName]="groupName"
        ></group-edit>
    `,
    standalone: false
})
export class AddNewGroupComponent {
    @Input()
    isTeamDiscovery = false;
    @Input()
    isSelfServe = false;
    @Input()
    groupSet: List<any> = List();
    @Input()
    groupName = '';

    constructor(
        public TR: TranslationService,
        public util: Util,
        public context: ContextDataService,
        public groups: GroupsDataService,
        public peekService: PeekService,
        private router: Router,
        private flags: FeatureFlagsService,
        private moduleAcess: ModuleAccessService
    ) {}

    navigateToNewGroup(groupId: string) {
        this.peekService.setOpen(false);
        if (this.isSelfServe && this.isTeamDiscovery) {
            this.router.navigate([
                '/design/' + dreamTeamsSelfServeRoutePath,
                groupId
            ]);
        } else if (this.isTeamDiscovery) {
            if (
                this.moduleAcess.isLegacyWithDesign2 ||
                this.flags.getByFlag(FeatureFlags.hasPaidDesignTwoAccess)
            ) {
                this.router.navigate([`/design/team/${groupId}`]);
            } else {
                this.router.navigate([
                    '/design/' + dreamTeamsRoutePath,
                    groupId
                ]);
            }
        } else {
            this.router.navigate(['/groups', groupId]);
        }
    }

    getInvitationSource() {
        return this.isTeamDiscovery
            ? InvitationSource.Design
            : InvitationSource.Unknown;
    }
}
